import { FormTitle } from 'components/Titles';

import { Box, Grid } from '@mui/material';

type IPartnerHeader = {
  borderOrange: string;
  logo: string;
};

export const PartnerHeader: React.FC<IPartnerHeader> = ({
  borderOrange,
  logo,
}) => {
  return (
    <>
      <FormTitle title="DADOS CADASTRAIS" />

      <Grid item container xs={6} md={2} justifyContent="flex-end">
        <Box
          height={94}
          width={94}
          borderRadius="100%"
          border="solid"
          borderColor={borderOrange}
          overflow="hidden"
        >
          <img width={90} height={90} src={logo} alt="" />
        </Box>
      </Grid>
    </>
  );
};

